var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFloppyDisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6626 8.14097V18.1687C18.6626 18.351 18.5902 18.5259 18.4612 18.6548C18.3323 18.7838 18.1574 18.8562 17.9751 18.8562H4.2251C4.04276 18.8562 3.86789 18.7838 3.73896 18.6548C3.61003 18.5259 3.5376 18.351 3.5376 18.1687V4.4187C3.5376 4.23636 3.61003 4.0615 3.73896 3.93257C3.86789 3.80363 4.04276 3.7312 4.2251 3.7312H14.2528C14.3431 3.7312 14.4325 3.74898 14.5159 3.78353C14.5993 3.81808 14.6751 3.86873 14.739 3.93257L18.4612 7.65484C18.5251 7.71868 18.5757 7.79447 18.6103 7.87788C18.6448 7.96129 18.6626 8.05069 18.6626 8.14097Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1006 16.1069C12.4295 16.1069 13.5068 15.0296 13.5068 13.7007C13.5068 12.3717 12.4295 11.2944 11.1006 11.2944C9.77165 11.2944 8.69434 12.3717 8.69434 13.7007C8.69434 15.0296 9.77165 16.1069 11.1006 16.1069Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8501 8.54443H8.3501V3.73193",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDisk);
export default __webpack_public_path__ + "static/media/FloppyDisk.4be3eaff4f33bf0e35b52cb37d53e878.svg";
export { ForwardRef as ReactComponent };